import { render, staticRenderFns } from "./RegPage.vue?vue&type=template&id=56f1f2be&scoped=true&"
import script from "./RegPage.vue?vue&type=script&lang=js&"
export * from "./RegPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1f2be",
  null
  
)

export default component.exports